module.exports = "/static/images/attractions.jpg";